import { Select } from "@chakra-ui/react";
import React from "react";
export const SelectControl = (props) => {
    return (React.createElement(Select, { value: props.value, onChange: event => { var _a; return props.onChange((_a = props.options.find(option => option.value === event.target.value)) !== null && _a !== void 0 ? _a : props.options[0]); } }, props.options.map(option => (React.createElement("option", { value: option.value, key: option.value }, option.label)))));
};
